import path from 'path-browserify'

export default function zipValidator(rules) {
  let errors = []

  const utils = {
    length({ files, length, message }) {
      if (files.length === length) return true
      return { files, length, message }
    },

    pattern({ files, pattern, message }) {
      if (files.every(file => pattern.test(path.parse(file).name))) return true
      return { files, pattern, message }
    },

    custom(params) {
      return params.validate(params)
    }
  }

  errors = rules
    .map(item => {
      if (item.validate) return utils.custom(item)
      if (item.rule) return utils[item.rule](item)
      return item
    })
    .filter(item => item !== true)

  return [errors.length === 0, errors]
}
